import { render, staticRenderFns } from "./review.vue?vue&type=template&id=d9bc4ab6&scoped=true&"
import script from "./review.vue?vue&type=script&lang=js&"
export * from "./review.vue?vue&type=script&lang=js&"
import style0 from "./review.vue?vue&type=style&index=0&id=d9bc4ab6&scoped=true&lang=css&"
import style1 from "./review.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9bc4ab6",
  null
  
)

export default component.exports